/* eslint-disable */
import { languageTag } from "../../runtime.js"
import * as en from "../en/share_ticket_link_created.js"
import * as nl from "../nl/share_ticket_link_created.js"
import * as de from "../de/share_ticket_link_created.js"


/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ forName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en" | "nl" | "de" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_ticket_link_created = (params , options = {}) => {
	return {
		de: de.share_ticket_link_created,
		en: en.share_ticket_link_created,
		nl: nl.share_ticket_link_created
	}[options.languageTag ?? languageTag()](params)
}

